<template>
  <t-form class="switchForm">
    <t-form-item :label="option.attribute.showLable?option.attribute.label:''">
      <t-space>
        <t-switch v-model="cptData.value" :size="option.attribute.size" :disabled="option.attribute.disabled"></t-switch>
      </t-space>
    </t-form-item>
</t-form>
</template>
  
  <script setup>
  import { MessagePlugin as Message } from 'tdesign-vue-next';
  import { getDataJson, pollingRefresh, getDefaultValue, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
  import { reactive ,ref, toRef,getCurrentInstance,watch,onMounted,computed} from "vue";
  const instance = getCurrentInstance()
  const props = defineProps({
      option: Object,
      current: Object
  })
  
  // 新增属性兼容旧代码
  const attr = props.option.attribute
  if (!attr.globalDataReload) attr.globalDataReload = [0]
  
  //uuid 必须
  let uuid = require('uuid').v1();
  //自定义组件值接收字段
  let cptData = reactive({});
  let newData = reactive({});
  let jsFunFlag = ref(false);
  
  //refreshCptData固定写法，必须！
  const refreshCptData = () => {
      pollingRefresh(uuid, props.option.cptDataForm, loadData)
  }
  //自定义数据处理方法
  const loadData = () => {
      getDataJson(props.option.cptDataForm, "", (res) => {
          //res为数据表单的静态数据或执行API返回的数据
          console.log("hahhahahahaah", res)
          newData = props.option.cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
          jsFunFlag.value = props.option.cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
          processData(props.option.cptDataForm, newData,jsFunFlag.value)
      })
  }
  const setStyles = computed(() => {
        return {
          '--labelColor': props.option.attribute.labelColor || 'rgba(255, 255, 255, 0.9)',
          "--fontSize": props.option.attribute.fontSize + "px",
        }
      })
  const processData = (cptDataForm, res, jsFunFlag,isFromGrid) => {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == '4') {
        if(props.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 
          console.log(res, 'res')
          // 第二层判断 ，如果没有配转换脚本
          if (jsFunFlag) { // 没有全部配置映射字段
              console.log(1)
              //判断此控件在九宫格里面就不请求数据
              
              console.log(JSON.parse(JSON.stringify(props.option.attribute.cptTableData)))
              let arr = JSON.parse(JSON.stringify(props.option.attribute.cptTableData))
              console.log(hasNonEmptyValues(arr))
              if (hasNonEmptyValues(arr)) {
                  console.log(2)
                  const dataKey = props.option.attribute.cptTableData;
                  // 创建一个新的数组用于存储结果
                  let newres = [];
                let newObj = {...res[0]};
              // 如果dataKey中的value有值并且在newObj对象中有对应的值
                // if (dataKey[0].value && newObj[dataKey[0].value]) {
                  newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
                // }
                newres.push(newObj);
                console.log(newres,'新数组');
                cptData.value = newres[0].value;
                console.log(cptData)
              }
          } else { // 如果配置了转换脚本
              console.log(3)
              cptData.value = res;
          }
          console.log(cptData,'cptData')
      } else { // 不是数据集类型，是静态数据
          console.log(4)
          Object.assign(cptData, res);
      }
      // 判断数据集中的值是否与配置的状态值一致 start
      switch (props.option.attribute.dataType) {
              case 'number':
                  props.option.attribute.openValue = 1;
                  props.option.attribute.closeValue = 0;
                  break;
              case 'string':
                  props.option.attribute.openValue = String(props.option.attribute.openValue);
                  props.option.attribute.closeValue = String(props.option.attribute.closeValue);
                  break;
              case 'boolean':
                  props.option.attribute.openValue = true;
                  props.option.attribute.closeValue = false;
                 break;
          }
          if(cptData.value == props.option.attribute.openValue) {
            cptData.value = true
          } else if (cptData.value == props.option.attribute.closeValue) {
            cptData.value = false
          } else {
            // 提示错误
            // Message.warning('开关控件数据集值与配置的状态值不一致，请检查！')
          }
      // 判断数据集中的值是否与配置的状态值一致 end
  }

  const setValue = (value) => {
    cptData.value = value
  }
  const getValue = () => {
    console.log(cptData.value,'this.cptData.valuethis.cptData.value')
    return cptData.value ? 'Y' : 'N'
  }
  let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
  
  watch(props.option.attribute,()=>{
      processData(props.option.cptDataForm, newData,jsFunFlag.value)
  },{
      deep:true
  })
  watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  
  //初始化数据，可选。echarts类组件需要放在onMounted中执行！
  //refreshCptData()
  onMounted(() => {
      if (dataReload.value.includes(0)) {
        refreshCptData();
      }
    });
  //暴露refreshCptData，必须！
  defineExpose({ refreshCptData, setValue, getValue,setStyles })
  </script>

<style scoped>
.t-form :deep(.t-form__controls){
  margin-left: 0px !important;
}
.switchForm :deep .t-form__label {
  color: var(--labelColor);
  font-size: var(--fontSize);
}
</style>